import {
  DashboardSquare01Icon,
  LicenseMaintenanceIcon,
  FileEditIcon,
  User03Icon,
} from '@hugeicons/core-free-icons';
import { NavItem } from 'svnxii-ng-shared/components';

export const MAINTENANCE_NAV_ITEMS: NavItem[] = [
  {
    title: 'Dashboard',
    icon: DashboardSquare01Icon,
    route: '/app/maintenance/dashboard',
  },
  {
    title: 'Inspection Requests',
    icon: LicenseMaintenanceIcon,
    route: '/app/maintenance/inspection-requests',
  },
  {
    title: 'VIN PDIs',
    icon: FileEditIcon,
    route: '/app/maintenance/vin-pdis',
    isVisible: (baselineKey) =>
      baselineKey === 'WorkshopLeader' || baselineKey === 'WorkshopManager',
    devFeature: true,
  },
  {
    title: 'Account',
    devFeature: true,
    icon: User03Icon,
    route: '/app/maintenance/notifications',
  },
];
